import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link, Redirect } from 'react-router-dom'
import {FormattedMessage, FormattedDate, injectIntl, defineMessages, FormattedRelative} from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import Pagination from '../common/listing/pagination.component.jsx'
import GlobalHelper from "../common/GlobalHelper.jsx";
import NoResult from "../common/listing/noresult.component.jsx";
import Search from '../common/search-filter/search/search.component.jsx';
import QuestionConversationChatModal from "../question-conversation/questionconversationchatmodal.jsx";
import Icon from "../common/icon/icon.component.jsx";
import ConversationStatusComponent from "./components/ConversationStatusComponent.tsx";

const messages = defineMessages({
    "search_message_placeholder": {
        id: 'message.listing.placeholder.search_message',
        defaultMessage: 'Search messages...',
    },
})

class MessageListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            headers: [],
            rows: [],
            modal: '',
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            loading: true,
            searchKeywords: '',
            sortField: 'lastCustomerMessage.createdAt',
            asc: false,
            object: ["projects"],
            data: '',
            filtersToUse: {},
            accountLimit: null,
            prefLoaded: false,
            savedFilterId: '',
        }

        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.onCloseModal = this.onCloseModal.bind(this)
        this.openConversationModal = this.openConversationModal.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this)
        this.initSearchComponent = this.initSearchComponent.bind(this)
        this.savePref = this.savePref.bind(this)
        this.refreshSearch = this.refreshSearch.bind(this)
        this.updateListing = this.updateListing.bind(this)
        this.refresh = this.refresh.bind(this)
    }

    componentDidMount() {
        GlobalHelper.getListingPreferences('listingInbox', true).then(pref => {
            this.setState({
                activePage: pref.page || 1,
                pageSize: pref.pageSize || 10,
                searchKeywords: pref.keywords || '',
                sortField: pref.sortField || 'lastCustomerMessage.createdAt',
                asc: pref.asc || false,
                filtersToUse: pref.filters || {},
                savedFilterId: pref.savedFilterId || ''
            }, () => { this.initSearchComponent() })
        }, () => this.initSearchComponent())


        SideBar.activateMenu('inbox')
    }

    initSearchComponent() {
        this.setState({ object: ["projects"], prefLoaded: true })
    }

    savePref() {
        return GlobalHelper.saveListingPreferences(
            'listingInbox',
            this.state.activePage,
            this.state.pageSize,
            this.state.searchKeywords,
            "",
            false,
            false,
            this.state.sortField,
            this.state.asc,
            this.state.filtersToUse,
            this.state.savedFilterId,
        )
    }

    handlePageSizeChange(size) {
        this.setState({
            pageSize: size
        }, () => {
            this.updateListing(true, false, this.state.data)
        })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.updateListing(true, false, this.state.data)
        })
    }

    handleSearchChange(event) {
        const target = event.target;
        this.setState({
            searchKeywords: target.value,
            activePage: 1,
        }, () => {
            this.updateListing(true, false, this.state.data)
        })
    }

    refreshSearch(savePrefs, refreshTotal, refreshStatBox, data, filtersToUse, searchKeywords, savedFilterId) {
        if (savePrefs) {
            this.setState({
                data: data,
                statBox: refreshStatBox ? "" : this.state.statBox,
                searchKeywords: searchKeywords,
                filtersToUse: filtersToUse,
                activePage: 1,
                loading: false,
                savedFilterId: savedFilterId,
            },
                () => {
                    this.updateListing(savePrefs, refreshTotal, data)
                })

        } else {
            this.updateListing(savePrefs, refreshTotal, data)
        }
    }

    updateListing(savePref, refreshTotal, data) {
        this.setState({
            loading: true,
        })
        let newData = Object.assign(data)
        newData.filters.hasConversation = true
        newData['pageSize'] = this.state.pageSize
        newData['activePage'] = this.state.activePage
        newData['sortAsc'] = this.state.asc
        newData['sortByField'] = this.state.sortField

        AppContext.getApiClient().post('/listing/search', newData).then(res => {
            this.setState({
                data: newData,
                headers: res.data.length > 0 ? this.headers() : [],
                rows: res.data.map(q => this.row(q)),
                totalItemsCount: res.metadata.totalItemsCount,
                loading: false,
            })
        })
        if (savePref) {
            this.savePref()
        }
    }

    openConversationModal(projectId) {
        return function (event) {
            event.preventDefault()
            this.setState({
                modal: <QuestionConversationChatModal
                    projectId={projectId}
                    displaySessionInfo={true}
                    onClose={this.onCloseModal} />
            })
        }.bind(this)

    }

    onCloseModal(quoteId) {
        let modal = ''
        if (quoteId) {
            modal = <Redirect to={'/quotes/' + quoteId + '/edit'} />
        }
        this.setState({
            modal: modal
        })
        this.updateListing(true, false, this.state.data)
    }

    headers() {
        return [
            <FormattedMessage
                id="listing.inbox.list.headers.contact_label"
                defaultMessage="Contact"
            />,
            <FormattedMessage
                id="listing.inbox.list.headers.message_label"
                defaultMessage="Message"
            />,
            <FormattedMessage
                id="listing.inbox.list.headers.status_label"
                defaultMessage="Status"
            />,
            <FormattedMessage
                id="listing.inbox.list.headers.received_date_label"
                defaultMessage="Date"
            />,
        ]
    }


    row(project) {
        let content = ''
        if (project.lastCustomerMessage) {
            content = project.lastCustomerMessage.content.substring(0, 100)
            if (project.lastCustomerMessage.content.length > 100) {
                content = content + '...'
            }
        }
        return {
            rowId: project.id,
            data: [
                <Link to={'/contacts/' + project.contactId + '/details'}>
                    {project.contact.name}
                </Link>,
                <a href={'#'} onClick={this.openConversationModal(project.id)}>
                    <Icon value={'envelope'} className={'mr-2'} />{content}
                </a>,
                <ConversationStatusComponent status={project.conversationStatus} />,
                <FormattedRelative value={new Date(project.lastCustomerMessage.createdAt)} />,
            ],
            classNames: ['', '', '']
        }
    }

    refresh() {
        this.updateListing(true, false, this.state.data)
    }

    render() {
        if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
            return <Redirect to={{ pathname: '/' }} />
        }


        let list = <StandardList
            smallLine={true}
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
            searchData={this.state.data}
            pageSize={this.state.pageSize}
            totalItemsCount={this.state.totalItemsCount}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        } else if (this.state.rows.length === 0) {
            list = <NoResult noButton={true} />
        }

        return (
            <div>
                {this.state.modal}
                {this.state.prefLoaded ?
                    <Search
                        onChange={this.refreshSearch}
                        searchBarClass={"col-md-4"}
                        childrenClass={"col-md-4"}
                        key="searchMessages"
                        typeOfSearch="messages"
                        searchKeywords={this.state.searchKeywords}
                        filtersToUse={this.state.filtersToUse}
                        filterVersion={this.state.filtersToUse}
                        object={this.state.object}
                        placeholder={this.props.intl.formatMessage(messages["search_message_placeholder"])}
                        savedFilterId={this.state.savedFilterId}
                    >
                        <button onClick={this.refresh} className="btn btn-primary">
                            <Icon value={"sync"} />
                            <FormattedMessage
                                id="messages.listing.refresh_button"
                                defaultMessage="Refresh"
                            />
                        </button>
                    </Search>: ''
                }
                {list}
                <Pagination
                    showPageSize={true}
                    onPageSizeChange={this.handlePageSizeChange}
                    activePage={this.state.activePage}
                    pageSize={this.state.pageSize}
                    totalItemsCount={this.state.totalItemsCount}
                    onChange={this.handlePageChange}
                />
            </div>
        );
    }
}

export default injectIntl(MessageListing);






// WEBPACK FOOTER //
// ./src/inbox/list.component.jsx